/**
 * @author Kelnik
 *
 * Tooltip - tooltip with Popper.js
 */

import 'tippy.js/dist/tippy.css';
import tippy from 'tippy.js';
import Utils from 'common/scripts/utils';

class Tooltip {
    constructor() {
        this.containerSelector = '.j-tooltip';
        this.tooltipsObj = [];
    }

    init() {
        this._initElements();
        this._initTippy();
        this._setPlacement();
        this._bindEvents();
    }

    _initElements() {
        this.tooltips = Array.from(document.querySelectorAll(this.containerSelector));
    }

    _initTippy() {
        this.tooltips.forEach((tooltip) => {
            if (tooltip.hasAttribute('init')) {
                return;
            }

            tooltip.setAttribute('init', '');

            const content = tooltip.dataset.content || null;
            const contentEl = document.querySelector(tooltip.dataset.contentSelector);
            const closes = contentEl ? Array.from(contentEl.querySelectorAll('.j-tooltip-close')) : [];

            if (!content && !contentEl) {
                return;
            }

            if (contentEl) {
                contentEl.style.display = 'block';
            }

            const tooltipObj = tippy(tooltip, {
                placement    : tooltip.dataset.placement || 'top',
                placementSave: tooltip.dataset.placement || 'top',
                trigger      : tooltip.dataset.trigger || 'mouseenter',
                triggerSave  : tooltip.dataset.trigger || 'mouseenter',
                content      : content || contentEl,
                interactive  : tooltip.dataset.interactive || false,
                maxWidth     : Number(tooltip.dataset.maxWidth) || 350
            });

            closes.forEach((close) => {
                close.addEventListener('click', () => {
                    tooltipObj.hide();
                });
            });

            this.tooltipsObj.push(tooltipObj);
        });
    }

    _bindEvents() {
        window.addEventListener('resize', Utils.debounce(this._setPlacement.bind(this), 500));
    }

    _setPlacement() {
        if (window.innerWidth < 670) {
            this.tooltipsObj.forEach((tooltip) => {
                if (!(tooltip.props.placementSave === 'top' || tooltip.props.placementSave === 'bottom')) {
                    tooltip.setProps({
                        placement: 'bottom',
                        trigger  : 'click'
                    });
                }
            });
        } else {
            this.tooltipsObj.forEach((tooltip) => {
                if (!(tooltip.props.placementSave === 'top' || tooltip.props.placementSave === 'bottom')) {
                    tooltip.setProps({
                        placement: tooltip.props.placementSave,
                        trigger  : tooltip.props.triggerSave
                    });
                }
            });
        }
    }
}

export default Tooltip;
